import { Component, Inject, OnInit } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

@Component({
    selector: 'app-error-popup',
    templateUrl: './error-popup.component.html',
    styleUrls: ['./error-popup.component.scss'],
    standalone: false
})
export class ErrorPopupComponent implements OnInit {

  errors:any;

  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: any, private snackBarRef: MatSnackBarRef<ErrorPopupComponent>) {
    this.errors = Object.values(data.message);
  }

  dismiss(){
    this.snackBarRef.dismiss();
  }

  ngOnInit(): void {
  }

}
